<template>
  <div class="loading">
    <pb-icon class="fas fa-spinner fa-pulse fa-3x fa-fw" />
  </div>
</template>

<script>
export default {
  name: 'Loading',
  data() {
    return {
      portal: this.$portal,
    };
  },
};
</script>

<style scoped lang="scss">
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90vh;
}
</style>
